import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (typeof TomSelect === "undefined") return

    this.ts = new TomSelect(this.element, {
      create: false,
      allowEmptyOption: true,
      maxOptions: null,
      plugins: ["remove_button"],
      placeholder: this.element.dataset.tomSelectPlaceholder || "Clique e pesquise ou selecione..."
    })
  }

  disconnect() {
    if (this.ts) { this.ts.destroy(); this.ts = null }
  }
}
